import { atom } from 'jotai';

import { showVideoAtom, videoAtom } from '../../video/atoms';
import { declineCallApi, joinChannelApi } from '../api/http';

type IncomingCall =
    | {
          hasIncomingCall: false;
      }
    | IncomingCallInfo;

export interface IncomingCallInfo {
    hasIncomingCall: true;
    incomingNotification: IncomingNotification;
}

export interface IncomingNotification {
    meetingId: string;
    callerUserProfileId: number;
    callerChatProviderUserId: string;
}

export const incomingCallAtom = atom<IncomingCall>({ hasIncomingCall: false });
export const eventIdAtom = atom<number>(-1);
export const isJoinErrorAtom = atom<boolean>(false);

export const joinChannelAtom = atom(null, async (get, set, guestProfileId: number) => {
    const incomingCall = get(incomingCallAtom);
    if (!incomingCall.hasIncomingCall) {
        return;
    }
    const eventId = get(eventIdAtom);
    const { meetingId, callerUserProfileId } = incomingCall.incomingNotification;
    set(isJoinErrorAtom, false);
    set(incomingCallAtom, { hasIncomingCall: false });
    set(showVideoAtom, true);

    try {
        const { id, meetingChannel } = await joinChannelApi(eventId, meetingId);

        set(videoAtom, {
            callerUserProfileId,
            guestProfileId,
            meetingId: id,
            agora: {
                agoraChannelId: meetingChannel.channelId,
                uid: meetingChannel.uid,
                token: meetingChannel.token,
                streamId: meetingChannel.streamId,
            },
        });
    } catch (e) {
        set(isJoinErrorAtom, true);
    }
});

export const declineCallAtom = atom(null, (get, set) => {
    const incomingCall = get(incomingCallAtom);
    if (!incomingCall.hasIncomingCall) {
        return;
    }
    const { meetingId } = incomingCall.incomingNotification;
    const eventId = get(eventIdAtom);
    declineCallApi(eventId, meetingId);
    set(incomingCallAtom, { hasIncomingCall: false });
});
